import { RefObject, useEffect, useState } from "react";

/**
 * Tracks a container element's live `clientWidth` via ResizeObserver — used
 * everywhere a waveform visualizer needs a numeric canvas width instead of a
 * CSS width (react-audio-visualize takes a literal pixel width, not a class).
 */
export const useElementWidth = (
  ref: RefObject<HTMLElement | null>,
  deps: unknown[] = []
) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setWidth(el.clientWidth);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return width;
};
